var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger m-1",attrs:{"type":"button"},on:{"click":_vm.remove}},[_c('span',{staticClass:"fas fa-trash-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }